export enum PeriodTypes {
	ProgramVersion = 0,
	// Course = 1,
	// Term = 2,
	PaymentPeriod = 3,
	AcademicYear = 4
}
